<template>
  <div class="product-section">
    <form-vue ref="fqcRef" @updateTable="updateTable" :type="props.type"
      :closedLoopAuthority="props.closedLoopAuthority"></form-vue>

    <div class="df vertical df-around" v-if="props.type !== 'oqc' && props.type !== 'fqc'">
      <div class="title">{{ query.localDate }} 质检信息</div>
    </div>

    <div v-else style="padding: 0 20px">
      <a-space class="space">
        <!-- <a-date-picker
          v-model:value="query.localDate"
          placeholder="日期"
          allowClear
          @change="hanldeSelectDate"
        ></a-date-picker> -->

        <a-cascader v-model:value="modelSpecifications" placeholder="型号规格" :options="modelSpecificationsOption"
          allowClear @change="handleSelectModel">
        </a-cascader>

        <a-select v-model:value="query.status" placeholder="状态" allowClear @change="handleSearch">
          <a-select-option value="未检">未检</a-select-option>
          <a-select-option value="合格">合格</a-select-option>
          <a-select-option value="不合格">不合格</a-select-option>
        </a-select>
        <a-input v-model:value="query.search" placeholder="搜索" allowClear @change="handleSearch"></a-input>
      </a-space>
    </div>

    <div ref="tableScrollRef">
      <div class="df both-side" style="margin-top: 20px">
        <div style="margin: 0 auto; width: calc(100vw - 160px)">
          <a-table :columns="getProductColumns" :loading="tableLoading" :data-source="tableData" :pagination="false"
            :rowClassName="(record, index) => (index % 1 === 0 ? 'table-striped' : null)
      " rowKey="id" bordered :scroll="{ x: 'calc(100vw - 160px)' }">

            <template #sourceProcess="{ record }">
              {{ getProcessName(record.sourceProcess) }}
            </template>
            <template #question1="{ record }">
              <div v-for="(img, index) in record.issuesImg1" :key="index">
                <a-image :width="50" :src="img" />
              </div>
              <div v-for="(video, index) in record.issuesVideo1" :key="index">
                <video :src="video" controls width="120" :key="video"></video>
              </div>
              <div v-for="(item, index) in record.issuesDesc1" :key="index">
                {{ item }}
              </div>
            </template>
            <template #questionType1="{ record }">
              <div v-if="record.questionType1">
                <div v-for="(item, index) in record.questionType1" :key="index">
                  {{ item }}
                </div>
              </div>
            </template>
            <template #reason1="{ record }">
              <div v-if="record.reason1">
                <div v-for="(item, index) in record.reason1" :key="index">
                  {{ item }}
                </div>
              </div>
            </template>
            <template #reason2="{ record }">
              <div v-if="record.reason2">
                <div v-for="(item, index) in record.reason2" :key="index">
                  {{ item }}
                </div>
              </div>
            </template>
            <template #solution1="{ record }">
              <div v-if="record.solution1">
                <div v-for="(item, index) in record.solution1" :key="index">
                  {{ item }}
                </div>
              </div>
            </template>
            <template #solution2="{ record }">
              <div v-if="record.solution2">
                <div v-for="(item, index) in record.solution2" :key="index">
                  {{ item }}
                </div>
              </div>
            </template>
            <template #question2="{ record }">
              <div v-for="(img, index) in record.issuesImg2" :key="index">
                <a-image :width="50" :src="img" />
              </div>
              <div v-for="(video, index) in record.issuesVideo2" :key="index">
                <video :src="video" controls width="120" :key="video"></video>
              </div>
              <div v-for="(item, index) in record.issuesDesc2" :key="index">
                {{ item }}
              </div>
            </template>
            <template #questionType2="{ record }">
              <div v-if="record.questionType2">
                <div v-for="(item, index) in record.questionType2" :key="index">
                  {{ item }}
                </div>
              </div>
            </template>

            <template #status="{ record }">
              <a-tag :color="setStatusColor(record.status)">
                {{ record.status }}
              </a-tag>
            </template>

            <template #notes="{ record }">
              <div v-if="record.notes">
                <template v-for="(item, index) in JSON.parse(record.notes)" :key="index">
                  <a-image v-for="img in JSON.parse(item.picture)" :key="img" :width="50" :src="img" />

                  <video v-for="video in JSON.parse(item.video)" :src="video" controls width="120" :key="video"></video>

                  <div>
                    {{ item.desc }}
                  </div>
                </template>
              </div>
            </template>

            <template #closedLoopStatus="{ record }">
              <closed-loop-status :closedLoopStatus="record.closedLoopStatus"></closed-loop-status>
            </template>
            <template #action="{ record }">
              <a-dropdown v-if="record.inspectionFrequency !== 1 || record.status === '不合格'
      ">
                <template #overlay size="small">
                  <a-menu @click="handleAction($event, record)">
                    <a-menu-item key="handleEdit">编辑</a-menu-item>
                    <!-- <a-menu-item key="handleInsertClosedLoop"
                      >新增闭环问题</a-menu-item
                    > -->
                    <a-menu-item key="handleInduction" v-if="props.closedLoopAuthority">问题归纳</a-menu-item>
                  </a-menu>
                </template>
                <a-button>
                  操作
                  <DownOutlined />
                </a-button>
              </a-dropdown>
            </template>
          </a-table>

          <div class="df both-side" style="margin-top: 20px" v-if="props.type === 'fqc' || props.type === 'oqc'">
            <div></div>
            <a-pagination size="small" :total="query.total" v-model:current="query.pageNum"
              v-model:lineNum="query.lineNum" @change="handleSelectPage" :show-total="(total) => `共 ${total} 条`" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <closed-loop-problem ref="closedLoopProblemRef"></closed-loop-problem>
</template>

<script>
import { computed, defineComponent, reactive, ref, inject, watch } from "vue";
import { useStore } from "vuex";
import { DownOutlined } from "@ant-design/icons-vue";
import { Toast, debounce, timeStampToTime } from "@/utils";
import { getPQCList } from "@/request/view/dailyQualityInspection";
import { getOQCList, getFQCList } from "@/request/view/warehouse";

import { saveProjectProblemClosedLoop } from "@/request/view/trialProductionCenter";
import { productColumns } from "@/views/productDaily/components/quality/PQC/threePieced/options";
import {
  getProcessName,
  modelSpecificationsOption,
} from "@/views/productDaily/serve/option";
import { getProcessesColumns } from "@/views/productDaily/components/quality/PQC/serve/option";
import searchVue from "@/views/productDaily/components/quality/PQC/threePieced/search.vue";
import formVue from "@/views/productDaily/components/product/components/qualityInspection/form.vue";
import SelectDay from "@/views/repairprogress/compoments/selectDay.vue";
import closedLoopProblem from "@/views/productDaily/components/product/components/qualityInspection/closedLoopProblem.vue";
import closedLoopStatus from "@/views/productDaily/components/closedLoopStatus.vue";

export default defineComponent({
  props: {
    type: String,
    closedLoopAuthority: Boolean,
    produceOrTpc: String,
  },
  components: {
    searchVue,
    formVue,
    SelectDay,
    DownOutlined,
    closedLoopProblem,
    closedLoopStatus,
  },
  setup(props, context) {
    const modelSpecifications = ref([]);

    const query = reactive({
      localDate: timeStampToTime("", "upload"),
      type: null,
      pageNum: 1,
      lineNum: 10,
      total: 0,
      status: null,
      produceOrTpc: props.produceOrTpc,
      modelSpecifications: null,
      search: null,
    });
    const store = useStore();

    const userId = computed(() => store.state.user.user.id);

    const tableLoading = ref(false);

    const searchRef = ref();

    const fqcRef = ref();

    const tableScrollRef = ref();

    const tableData = reactive([]);

    const closeLoopStatusColor = {
      不适用: "processing",
      进行中: "warning",
      已完成: "#87d068",
      未开始: "#f50",
    };

    const setStatusColor = (status) => {
      let color = "";
      switch (status) {
        case "未检":
          color = "orange";
          break;
        case "不合格":
          color = "#f50";
          break;
        case "合格":
          color = "#87d068";
          break;
        default:
          break;
      }
      return color;
    };
    const setColor = (text) => {
      const color = closeLoopStatusColor[text];
      if (!color) {
        return "default";
      }
      return color;
    };

    // 设置渲染数据
    const setmediaInfo = (list) => {
      if (!list) return;
      list.forEach((item) => {
        if (
          item.inspectionIssues &&
          item.inspectionIssues.indexOf("[") !== -1
        ) {
          const list = JSON.parse(item.inspectionIssues);
          if (typeof list === "object")
            list.forEach((issues, index) => {
              item[`issuesDesc${index + 1}`] = [];
              item[`issuesImg${index + 1}`] = [];
              item[`issuesVideo${index + 1}`] = [];
              item[`questionType${index + 1}`] = [];
              item[`solution${index + 1}`] = [];
              item[`reason${index + 1}`] = [];
              issues.list.forEach((media) => {
                item[`issuesImg${index + 1}`].push(
                  ...JSON.parse(media.picture)
                );
                item[`issuesVideo${index + 1}`].push(
                  ...JSON.parse(media.video)
                );
                item[`questionType${index + 1}`].push(media.type);
                item[`issuesDesc${index + 1}`].push(media.desc);
                item[`solution${index + 1}`].push(media.solution);
                item[`reason${index + 1}`].push(media.reason);
              });
              item[`inspectionPersonnel${index + 1}`] =
                issues.inspectionPersonnel;
              item[`qualityPersonnel${index + 1}`] = issues.qualityPersonnel;
            });
        }
      });
    };

    const getRequestByType = () => {
      let requestFn;
      let params = {};

      switch (props.type) {
        case "fqc":
          requestFn = getFQCList;
          params.pageNum = query.pageNum;
          params.lineNum = query.lineNum;
          params.status = query.status;
          params.modelSpecifications = query.modelSpecifications;
          params.localDate = query.localDate;
          break;
        case "oqc":
          requestFn = getOQCList;
          params.pageNum = query.pageNum;
          params.lineNum = query.lineNum;
          params.status = query.status;
          params.modelSpecifications = query.modelSpecifications;
          params.localDate = query.localDate;
          break;
        default:
          requestFn = getPQCList;
          query.type = props.type;
          params = query;
          break;
      }

      return {
        requestFn,
        params,
      };
    };

    // 获取PQC数据
    const getTableData = () => {
      const { requestFn, params } = getRequestByType();
      requestFn(params)
        .then((res) => {
          tableData.length = 0;
          if (res.code === 200 && res.message === "成功" && res.data) {
            try {
              if (props.type !== "fqc") {
                Object.keys(res.data).forEach((key) => {
                  setmediaInfo(res.data[key]);
                  tableData.push(...res.data[key]);
                });
              } else if (props.type === "fqc" || props.type === "oqc") {
                setmediaInfo(res.data.records);
                tableData.push(...res.data.records);
              }

              if (res.data.total) {
                query.total = res.data.total;
              }
            } catch (error) {
              console.log(error, "捕获到的错误是什么");
            }
          }
        })
        .catch((err) => { });
    };

    const handleEdit = (data) => {
      fqcRef.value.openModal("editPQC", data);
    };

    const userSelectDay = (time) => {
      if (time) {
        query.localDate = time;
        getTableData();
      }
    };

    const updateTable = () => {
      getTableData();
    };

    const handleInsertClosedLoop = (record) => {
      saveProjectProblemClosedLoop({
        serialNumber: record.serialNumber,
      }).then((res) => {
        const type = res.code === 200 ? "success" : "warning";
        Toast(type, res.message, 3);
      });
    };

    const closedLoopProblemRef = ref();

    const handleInduction = (record) => {
      closedLoopProblemRef.value.showModal(record);
    };

    const hadnleUpdateStatus = (e, record) => { };

    const handleAction = (e, record) => {
      const type = e.key;
      switch (type) {
        case "handleEdit":
          handleEdit(record);
          break;
        case "handleInsertClosedLoop":
          handleInsertClosedLoop(record);
          break;
        case "handleInduction":
          handleInduction(record);
          break;
        default:
          break;
      }
    };

    const handleSelectModel = (e) => {
      const [project, model] = e;
      query.modelSpecifications = model;
      query.pageNum = 1;
      getTableData();
    };

    const hanldeSelectDate = (e, stringTime) => {
      query.localDate = stringTime;
      query.pageNum = 1;
      getTableData();
    };

    const handleSearch = debounce(() => {
      query.pageNum = 1;
      getTableData();
    }, 50);

    const tabActivekey = inject("tabActivekey", null);

    watch(
      () => tabActivekey,
      (val) => {
        if (val.value === props.type) {
          query.pageNum = 1;
          query.lineNum = 10;
          query.status = null;
          query.modelSpecifications = null;
          query.search = null;
          modelSpecifications.value.length = 0;
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    const cascadeDate = inject("cascadeDate", null);

    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (date !== query.localDate) {
          query.localDate = date;
          query.pageNum = 1;
          query.lineNum = 10;
        }
        getTableData();
      },
      {
        immediate: true,
        deep: true,
      }
    );

    const otherFQCcolumns = [
      {
        index: 0,
        column: {
          title: "总装调试SN号",
          dataIndex: "assembleDebugsnNumber",
          align: "center",
          width: 200,
        },
      },
      {
        index: 5,
        column: {
          title: "新设备",
          slots: { customRender: "isNewDevice" },
          align: "center",
          width: 100,
        },
      },
    ];

    const otherOQCcolumns = [
      {
        index: 0,
        column: {
          title: "机身号",
          dataIndex: "serial",
          align: "center",
          width: 200,
        },
      },
    ];

    const handleSelectPage = (page, size) => {
      query.pageNum = page;
      query.lineNum = size;
      getTableData();
    };

    // 往指定的位置中插入
    const insertColumnsByIndex = (columns, list) => {
      list.forEach((item) => {
        const { index, column } = item;
        columns.splice(index, 0, column);
      });
    };

    const getProductColumns = computed(() => {
      let columns = getProcessesColumns();

      if (props.type === "fqc") {
        insertColumnsByIndex(columns, otherFQCcolumns);
        columns = columns.filter(
          (f) =>
            f.title !== "SN号" &&
            f.title !== "输出SN号" &&
            f.title !== "创建时间" &&
            f.title !== "闭环状态" &&
            f.title !== "来源工序"
        );
      }

      if (props.type === "oqc") {
        insertColumnsByIndex(columns, otherOQCcolumns);
        columns = columns.filter(
          (f) =>
            f.title !== "SN号" &&
            f.title !== "输出SN号" &&
            f.title !== "创建时间" &&
            f.title !== "闭环状态" &&
            f.title !== "来源工序"
        );
      }

      return columns;

      if (props.type === "fqc") {
        const list = [...productColumns];
        // list.splice(0, 1, {
        //   title: "机身号",
        //   dataIndex: "serial",
        //   width: 180,
        //   align: "center",
        // });
        list.splice(3, 0, {
          title: "新设备",
          slots: { customRender: "isNewDevice" },
          align: "center",
          width: 100,
        });
        return list;
      } else if (props.type === "oqc") {
        const list = [...productColumns];
        list.splice(0, 1, {
          title: "SN号",
          dataIndex: "serial",
          width: 180,
          align: "center",
        });
        return list;
      } else {
        return productColumns;
      }
    });

    return {
      props,
      query,
      userId,
      setColor,
      handleAction,
      closedLoopProblemRef,
      setStatusColor,
      getProductColumns,
      searchRef,
      fqcRef,
      tableData,
      tableLoading,
      userSelectDay,
      tableScrollRef,
      updateTable,
      handleEdit,
      getProcessName,
      hadnleUpdateStatus,
      modelSpecificationsOption,
      handleSelectModel,
      handleSearch,
      handleSelectPage,
      modelSpecifications,
      hanldeSelectDate,
    };
  },
});
</script>

<style lang="less" scoped></style>
